const i = {
  isXS: "(max-width: 639px)",
  isSM: "(min-width: 640px)",
  isMD: "(min-width: 768px)",
  isLG: "(min-width: 1024px)",
  isXL: "(min-width: 1280px)",
  is2XL: "(min-width: 1536px)"
};
export {
  i as breakpointQueries
};
